import { Directive, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive()
export class Destroyable implements OnDestroy {
  destroyed$ = new Subject<void>();

  takeUntilDestroyed(): (src: Observable<any>) => Observable<any> {
    return (src: Observable<any>) => src.pipe(takeUntil(this.destroyed$));
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
